import { MutationTree } from "vuex";
import { EventsUtilsStateInterface } from "./state";

const mutation: MutationTree<EventsUtilsStateInterface> = {
  setSwearWords(state: EventsUtilsStateInterface, payload: {
    swearWordsArray: string[],
    regExpSwearWords: RegExp | null
  }) {
    state.swearWordsArray = payload.swearWordsArray;
    state.regExpSwearWords = payload.regExpSwearWords;
  }
};

export default mutation;
